module.exports = __webpack_public_path__ + "img/card.289194d1.png";